var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-dialog', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "id": "add-csv-network",
            "color": "blue darken-2",
            "icon": "",
            "medium": "",
            "disabled": !_vm.userCanEdit
          }
        }, on), [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v(" mdi-plus-box-multiple ")])], 1)];
      }
    }]),
    model: {
      value: _vm.CSVNetworkDialog,
      callback: function callback($$v) {
        _vm.CSVNetworkDialog = $$v;
      },
      expression: "CSVNetworkDialog"
    }
  }, [_c('NetworkMultiCSVUploadForm', {
    attrs: {
      "workspace": _vm.workspace
    },
    on: {
      "success": _vm.CSVNetworkDialogSuccess
    }
  })], 1), _c('v-dialog', {
    attrs: {
      "width": "700"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "id": "add-network",
            "color": "blue darken-2",
            "icon": "",
            "medium": "",
            "disabled": !_vm.userCanEdit
          }
        }, on), [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v(" mdi-plus-circle ")])], 1)];
      }
    }]),
    model: {
      value: _vm.networkDialog,
      callback: function callback($$v) {
        _vm.networkDialog = $$v;
      },
      expression: "networkDialog"
    }
  }, [_c('v-card', [_c('v-tabs', [_c('v-tab', [_vm._v(" Upload ")]), _c('v-tab', [_vm._v(" Create ")]), _c('v-tab-item', [_c('network-upload-form', {
    attrs: {
      "workspace": _vm.workspace
    },
    on: {
      "success": _vm.networkDialogSuccess
    }
  })], 1), _c('v-tab-item', [_c('network-create-form', {
    attrs: {
      "edge-tables": _vm.edgeTables,
      "workspace": _vm.workspace
    },
    on: {
      "success": _vm.networkDialogSuccess
    }
  })], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }